import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { getBackendUrl } from "@/lib/backend";
import ExecutiveMapPanel from "@/components/ExecutiveMapPanel";

const API = `${getBackendUrl()}/api`;

const LandingDistrictMapSection = () => {
  const [mapData, setMapData] = useState(null);
  const [sqaafOverview, setSqaafOverview] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedDistrict, setSelectedDistrict] = useState("Pune");
  const [selectedMetric, setSelectedMetric] = useState("shi");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    Promise.allSettled([
      axios.get(`${API}/executive/district-map-data`),
      axios.get(`${API}/sqaaf/overview`),
    ])
      .then(([mapRes, sqaafRes]) => {
        if (cancelled) return;
        setMapData(mapRes.status === "fulfilled" ? mapRes.value?.data || null : null);
        setSqaafOverview(sqaafRes.status === "fulfilled" ? sqaafRes.value?.data || null : null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const resolvedSelected = useMemo(() => {
    const districts = mapData?.districts || [];
    if (districts.some((d) => d.district_name === selectedDistrict && d.has_data)) {
      return selectedDistrict;
    }
    return districts.find((d) => d.has_data)?.district_name || "Pune";
  }, [mapData?.districts, selectedDistrict]);

  return (
    <section className="section landing-map-section" id="district-map" aria-labelledby="landing-map-title">
      <div className="container">
        <div className="section-title landing-map-intro">
          <span className="section-icon">
            <svg className="svg-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z" />
              <circle cx="12" cy="10" r="3" />
            </svg>
          </span>
          <h2 id="landing-map-title">Maharashtra District Map</h2>
          <p>
            Explore school health and coverage indicators across every district. Click a district on the map to
            review its OSH score, enrolment and identity metrics.
          </p>
        </div>

        <div className="landing-map-shell">
          {loading ? (
            <article className="landing-map-panel">
              <div className="landing-map-stage landing-map-loading">Loading Maharashtra district map…</div>
            </article>
          ) : (
            <ExecutiveMapPanel
              data={mapData}
              selectedDistrict={resolvedSelected}
              onSelectDistrict={setSelectedDistrict}
              selectedMetric={selectedMetric}
              onMetricChange={setSelectedMetric}
              sqaafOverview={sqaafOverview}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default LandingDistrictMapSection;
